/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { ModelMeta } from "@zenstackhq/runtime";

const metadata: ModelMeta = {
    models: {
        user: {
            name: 'User', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, name: {
                    name: "name",
                    type: "String",
                    isOptional: true,
                }, email: {
                    name: "email",
                    type: "String",
                }, emailVerified: {
                    name: "emailVerified",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": false }] }],
                }, image: {
                    name: "image",
                    type: "String",
                    isOptional: true,
                }, firstName: {
                    name: "firstName",
                    type: "String",
                    isOptional: true,
                }, lastName: {
                    name: "lastName",
                    type: "String",
                    isOptional: true,
                }, role: {
                    name: "role",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": "user" }] }],
                }, banned: {
                    name: "banned",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": false }] }],
                }, banReason: {
                    name: "banReason",
                    type: "String",
                    isOptional: true,
                }, banExpires: {
                    name: "banExpires",
                    type: "DateTime",
                    isOptional: true,
                }, lastLoginMethod: {
                    name: "lastLoginMethod",
                    type: "String",
                    isOptional: true,
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, accounts: {
                    name: "accounts",
                    type: "Account",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, sessions: {
                    name: "sessions",
                    type: "Session",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, members: {
                    name: "members",
                    type: "Member",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, profile: {
                    name: "profile",
                    type: "Profile",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'user',
                }, propertySeeker: {
                    name: "propertySeeker",
                    type: "PropertySeeker",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'user',
                }, impersonatorUser: {
                    name: "impersonatorUser",
                    type: "ImpersonationLog",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'impersonatorUser',
                }, impersonatedUser: {
                    name: "impersonatedUser",
                    type: "ImpersonationLog",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'impersonatedUser',
                }, impersonatorSessions: {
                    name: "impersonatorSessions",
                    type: "ImpersonationSession",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'impersonatorUser',
                }, impersonatedSessions: {
                    name: "impersonatedSessions",
                    type: "ImpersonationSession",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'impersonatedUser',
                }, sessionLogs: {
                    name: "sessionLogs",
                    type: "UserSessionLog",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, avatarFile: {
                    name: "avatarFile",
                    type: "File",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'avatar',
                }, usersFiles: {
                    name: "usersFiles",
                    type: "File",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'userFile',
                }, accessibleFiles: {
                    name: "accessibleFiles",
                    type: "FileAccessControl",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, savedListings: {
                    name: "savedListings",
                    type: "SavedListing",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'person',
                }, comments: {
                    name: "comments",
                    type: "Comment",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                }, replies: {
                    name: "replies",
                    type: "Reply",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'user',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, email: {
                    name: "email",
                    fields: ["email"]
                },
            },
        },
        session: {
            name: 'Session', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, token: {
                    name: "token",
                    type: "String",
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, expiresAt: {
                    name: "expiresAt",
                    type: "DateTime",
                }, ipAddress: {
                    name: "ipAddress",
                    type: "String",
                    isOptional: true,
                }, userAgent: {
                    name: "userAgent",
                    type: "String",
                    isOptional: true,
                }, impersonatedBy: {
                    name: "impersonatedBy",
                    type: "String",
                    isOptional: true,
                }, activeOrganizationId: {
                    name: "activeOrganizationId",
                    type: "String",
                    isOptional: true,
                    isForeignKey: true,
                    relationField: 'organization',
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'sessions',
                    isRelationOwner: true,
                    onDeleteAction: 'Cascade',
                    foreignKeyMapping: { "id": "userId" },
                }, organization: {
                    name: "organization",
                    type: "Organization",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'sessions',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "activeOrganizationId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, token: {
                    name: "token",
                    fields: ["token"]
                },
            },
        },
        account: {
            name: 'Account', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, providerId: {
                    name: "providerId",
                    type: "String",
                }, accountId: {
                    name: "accountId",
                    type: "String",
                }, accessToken: {
                    name: "accessToken",
                    type: "String",
                    isOptional: true,
                }, refreshToken: {
                    name: "refreshToken",
                    type: "String",
                    isOptional: true,
                }, idToken: {
                    name: "idToken",
                    type: "String",
                    isOptional: true,
                }, accessTokenExpiresAt: {
                    name: "accessTokenExpiresAt",
                    type: "DateTime",
                    isOptional: true,
                }, refreshTokenExpiresAt: {
                    name: "refreshTokenExpiresAt",
                    type: "DateTime",
                    isOptional: true,
                }, scope: {
                    name: "scope",
                    type: "String",
                    isOptional: true,
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'accounts',
                    isRelationOwner: true,
                    onDeleteAction: 'Cascade',
                    foreignKeyMapping: { "id": "userId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, providerId_accountId: {
                    name: "providerId_accountId",
                    fields: ["providerId", "accountId"]
                },
            },
        },
        verification: {
            name: 'Verification', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, identifier: {
                    name: "identifier",
                    type: "String",
                }, value: {
                    name: "value",
                    type: "String",
                }, expiresAt: {
                    name: "expiresAt",
                    type: "DateTime",
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        organization: {
            name: 'Organization', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, name: {
                    name: "name",
                    type: "String",
                }, slug: {
                    name: "slug",
                    type: "String",
                }, logo: {
                    name: "logo",
                    type: "String",
                    isOptional: true,
                }, metadata: {
                    name: "metadata",
                    type: "Json",
                    isOptional: true,
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, members: {
                    name: "members",
                    type: "Member",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'organization',
                }, invitations: {
                    name: "invitations",
                    type: "Invitation",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'organization',
                }, business: {
                    name: "business",
                    type: "Business",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'organization',
                }, sessions: {
                    name: "sessions",
                    type: "Session",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'organization',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, slug: {
                    name: "slug",
                    fields: ["slug"]
                },
            },
        },
        member: {
            name: 'Member', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, organizationId: {
                    name: "organizationId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'organization',
                }, role: {
                    name: "role",
                    type: "String",
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'members',
                    isRelationOwner: true,
                    onDeleteAction: 'Cascade',
                    foreignKeyMapping: { "id": "userId" },
                }, organization: {
                    name: "organization",
                    type: "Organization",
                    isDataModel: true,
                    backLink: 'members',
                    isRelationOwner: true,
                    onDeleteAction: 'Cascade',
                    foreignKeyMapping: { "id": "organizationId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, userId_organizationId: {
                    name: "userId_organizationId",
                    fields: ["userId", "organizationId"]
                },
            },
        },
        invitation: {
            name: 'Invitation', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, email: {
                    name: "email",
                    type: "String",
                }, inviterId: {
                    name: "inviterId",
                    type: "String",
                }, organizationId: {
                    name: "organizationId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'organization',
                }, role: {
                    name: "role",
                    type: "String",
                }, status: {
                    name: "status",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": "pending" }] }],
                }, expiresAt: {
                    name: "expiresAt",
                    type: "DateTime",
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, organization: {
                    name: "organization",
                    type: "Organization",
                    isDataModel: true,
                    backLink: 'invitations',
                    isRelationOwner: true,
                    onDeleteAction: 'Cascade',
                    foreignKeyMapping: { "id": "organizationId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        jwks: {
            name: 'Jwks', fields: {
                id: {
                    name: "id",
                    type: "String",
                    isId: true,
                }, publicKey: {
                    name: "publicKey",
                    type: "String",
                }, privateKey: {
                    name: "privateKey",
                    type: "String",
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        file: {
            name: 'File', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$File$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$File$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, key: {
                    name: "key",
                    type: "String",
                }, name: {
                    name: "name",
                    type: "String",
                }, type: {
                    name: "type",
                    type: "String",
                }, url: {
                    name: "url",
                    type: "String",
                }, size: {
                    name: "size",
                    type: "Int",
                }, isPublic: {
                    name: "isPublic",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": false }] }],
                }, status: {
                    name: "status",
                    type: "FileStatus",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, userFileId: {
                    name: "userFileId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'userFile',
                }, userFile: {
                    name: "userFile",
                    type: "User",
                    isDataModel: true,
                    backLink: 'usersFiles',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userFileId" },
                }, availableTo: {
                    name: "availableTo",
                    type: "FileAccessControl",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'file',
                }, avatarId: {
                    name: "avatarId",
                    type: "String",
                    isOptional: true,
                    isForeignKey: true,
                    relationField: 'avatar',
                }, avatar: {
                    name: "avatar",
                    type: "User",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'avatarFile',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "avatarId" },
                }, commentId: {
                    name: "commentId",
                    type: "String",
                    isOptional: true,
                    isForeignKey: true,
                    relationField: 'comment',
                }, comment: {
                    name: "comment",
                    type: "Comment",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'files',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "commentId" },
                }, replyId: {
                    name: "replyId",
                    type: "String",
                    isOptional: true,
                    isForeignKey: true,
                    relationField: 'reply',
                }, reply: {
                    name: "reply",
                    type: "Reply",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'files',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "replyId" },
                }, listingId: {
                    name: "listingId",
                    type: "String",
                    isOptional: true,
                    isForeignKey: true,
                    relationField: 'listing',
                }, listing: {
                    name: "listing",
                    type: "Listing",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'files',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listingId" },
                }, orderIndex: {
                    name: "orderIndex",
                    type: "Int",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": 0 }] }],
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, avatarId: {
                    name: "avatarId",
                    fields: ["avatarId"]
                },
            },
        },
        fileAccessControl: {
            name: 'FileAccessControl', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$FileAccessControl$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$FileAccessControl$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, fileId: {
                    name: "fileId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'file',
                }, file: {
                    name: "file",
                    type: "File",
                    isDataModel: true,
                    backLink: 'availableTo',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "fileId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'accessibleFiles',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, fileId_userId: {
                    name: "fileId_userId",
                    fields: ["fileId", "userId"]
                },
            },
        },
        featuredListing: {
            name: 'FeaturedListing', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$FeaturedListing$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$FeaturedListing$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, listingId: {
                    name: "listingId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'listing',
                }, listing: {
                    name: "listing",
                    type: "Listing",
                    isDataModel: true,
                    backLink: 'featuredListings',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listingId" },
                }, startDate: {
                    name: "startDate",
                    type: "DateTime",
                }, endDate: {
                    name: "endDate",
                    type: "DateTime",
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        listing: {
            name: 'Listing', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Listing$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Listing$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, slug: {
                    name: "slug",
                    type: "String",
                    isOptional: true,
                }, status: {
                    name: "status",
                    type: "ListingStatus",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, businessId: {
                    name: "businessId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'business',
                }, business: {
                    name: "business",
                    type: "Business",
                    isDataModel: true,
                    backLink: 'listings',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "businessId" },
                }, title: {
                    name: "title",
                    type: "String",
                }, description: {
                    name: "description",
                    type: "Json",
                }, files: {
                    name: "files",
                    type: "File",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'listing',
                }, details: {
                    name: "details",
                    type: "ListingDetails",
                    isTypeDef: true,
                }, forLease: {
                    name: "forLease",
                    type: "ForLease",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'listing',
                }, atAuction: {
                    name: "atAuction",
                    type: "AuctionFormat",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'listing',
                }, savedListings: {
                    name: "savedListings",
                    type: "SavedListing",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'listing',
                }, featuredListings: {
                    name: "featuredListings",
                    type: "FeaturedListing",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'listing',
                }, comments: {
                    name: "comments",
                    type: "Comment",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'listing',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        forLease: {
            name: 'ForLease', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ForLease$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ForLease$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, listingId: {
                    name: "listingId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'listing',
                }, listing: {
                    name: "listing",
                    type: "Listing",
                    isDataModel: true,
                    backLink: 'forLease',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listingId" },
                }, availableFrom: {
                    name: "availableFrom",
                    type: "DateTime",
                }, leaseTermMonths: {
                    name: "leaseTermMonths",
                    type: "Int",
                }, tenantScreeningCriteria: {
                    name: "tenantScreeningCriteria",
                    type: "TenantScreeningCriteria",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'leaseTerms',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, listingId: {
                    name: "listingId",
                    fields: ["listingId"]
                },
            },
        },
        auctionFormat: {
            name: 'AuctionFormat', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$AuctionFormat$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$AuctionFormat$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, listingId: {
                    name: "listingId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'listing',
                }, listing: {
                    name: "listing",
                    type: "Listing",
                    isDataModel: true,
                    backLink: 'atAuction',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listingId" },
                }, auctionStartDate: {
                    name: "auctionStartDate",
                    type: "DateTime",
                }, auctionEndDate: {
                    name: "auctionEndDate",
                    type: "DateTime",
                }, startingBid: {
                    name: "startingBid",
                    type: "Decimal",
                }, reserveBidAmount: {
                    name: "reserveBidAmount",
                    type: "Decimal",
                    isOptional: true,
                }, bidIncrement: {
                    name: "bidIncrement",
                    type: "Decimal",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": 10 }] }],
                }, bids: {
                    name: "bids",
                    type: "Bid",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'auction',
                }, winningBidId: {
                    name: "winningBidId",
                    type: "String",
                    isOptional: true,
                    isForeignKey: true,
                    relationField: 'winningBid',
                }, winningBid: {
                    name: "winningBid",
                    type: "Bid",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'won',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "winningBidId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, listingId: {
                    name: "listingId",
                    fields: ["listingId"]
                }, winningBidId: {
                    name: "winningBidId",
                    fields: ["winningBidId"]
                },
            },
        },
        bid: {
            name: 'Bid', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Bid$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Bid$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, auctionId: {
                    name: "auctionId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'auction',
                }, auction: {
                    name: "auction",
                    type: "AuctionFormat",
                    isDataModel: true,
                    backLink: 'bids',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "auctionId" },
                }, propertySeekerId: {
                    name: "propertySeekerId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'propertySeeker',
                }, propertySeeker: {
                    name: "propertySeeker",
                    type: "PropertySeeker",
                    isDataModel: true,
                    backLink: 'bids',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "propertySeekerId" },
                }, won: {
                    name: "won",
                    type: "AuctionFormat",
                    isDataModel: true,
                    isOptional: true,
                    backLink: 'winningBid',
                }, currentBidAmount: {
                    name: "currentBidAmount",
                    type: "Decimal",
                }, placedBy: {
                    name: "placedBy",
                    type: "BidPlacedBy",
                }, maxBidAmount: {
                    name: "maxBidAmount",
                    type: "Decimal",
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        savedListing: {
            name: 'SavedListing', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$SavedListing$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$SavedListing$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, listingId: {
                    name: "listingId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'listing',
                }, listing: {
                    name: "listing",
                    type: "Listing",
                    isDataModel: true,
                    backLink: 'savedListings',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listingId" },
                }, personId: {
                    name: "personId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'person',
                }, person: {
                    name: "person",
                    type: "User",
                    isDataModel: true,
                    backLink: 'savedListings',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "personId" },
                }, isSaved: {
                    name: "isSaved",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": true }] }],
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, listingId_personId: {
                    name: "listingId_personId",
                    fields: ["listingId", "personId"]
                },
            },
        },
        comment: {
            name: 'Comment', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Comment$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Comment$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, listingId: {
                    name: "listingId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'listing',
                }, listing: {
                    name: "listing",
                    type: "Listing",
                    isDataModel: true,
                    backLink: 'comments',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "listingId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'comments',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, content: {
                    name: "content",
                    type: "Json",
                }, files: {
                    name: "files",
                    type: "File",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'comment',
                }, replies: {
                    name: "replies",
                    type: "Reply",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'comment',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        reply: {
            name: 'Reply', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Reply$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Reply$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, commentId: {
                    name: "commentId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'comment',
                }, comment: {
                    name: "comment",
                    type: "Comment",
                    isDataModel: true,
                    backLink: 'replies',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "commentId" },
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'replies',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                }, content: {
                    name: "content",
                    type: "Json",
                }, files: {
                    name: "files",
                    type: "File",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'reply',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        business: {
            name: 'Business', fields: {
                slug: {
                    name: "slug",
                    type: "String",
                    isOptional: true,
                }, createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Business$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Business$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, organizationId: {
                    name: "organizationId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'organization',
                }, organization: {
                    name: "organization",
                    type: "Organization",
                    isDataModel: true,
                    backLink: 'business',
                    isRelationOwner: true,
                    onDeleteAction: 'Cascade',
                    foreignKeyMapping: { "id": "organizationId" },
                }, businessName: {
                    name: "businessName",
                    type: "String",
                }, emails: {
                    name: "emails",
                    type: "Email",
                    isTypeDef: true,
                    isArray: true,
                }, addresses: {
                    name: "addresses",
                    type: "Address",
                    isTypeDef: true,
                    isArray: true,
                }, phoneNumbers: {
                    name: "phoneNumbers",
                    type: "PhoneNumber",
                    isTypeDef: true,
                    isArray: true,
                }, websites: {
                    name: "websites",
                    type: "Website",
                    isTypeDef: true,
                    isArray: true,
                }, listings: {
                    name: "listings",
                    type: "Listing",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'business',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, organizationId: {
                    name: "organizationId",
                    fields: ["organizationId"]
                },
            },
        },
        propertySeeker: {
            name: 'PropertySeeker', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$PropertySeeker$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$PropertySeeker$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$PropertySeeker$id,
                    isForeignKey: true,
                    relationField: 'user',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'propertySeeker',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "id" },
                }, biography: {
                    name: "biography",
                    type: "Json",
                    isOptional: true,
                }, creditScoreRange: {
                    name: "creditScoreRange",
                    type: "CreditScoreRange",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, annualIncome: {
                    name: "annualIncome",
                    type: "AnnualIncome",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, mostRecentEviction: {
                    name: "mostRecentEviction",
                    type: "MostRecentEviction",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, mostRecentEvictionProvided: {
                    name: "mostRecentEvictionProvided",
                    type: "DateTime",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, bids: {
                    name: "bids",
                    type: "Bid",
                    isDataModel: true,
                    isArray: true,
                    backLink: 'propertySeeker',
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        tenantScreeningCriteria: {
            name: 'TenantScreeningCriteria', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$TenantScreeningCriteria$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$TenantScreeningCriteria$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, leaseTermsId: {
                    name: "leaseTermsId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'leaseTerms',
                }, leaseTerms: {
                    name: "leaseTerms",
                    type: "ForLease",
                    isDataModel: true,
                    backLink: 'tenantScreeningCriteria',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "leaseTermsId" },
                }, isEnabled: {
                    name: "isEnabled",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": true }] }],
                }, creditScoreRange: {
                    name: "creditScoreRange",
                    type: "CreditScoreRange",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, annualIncome: {
                    name: "annualIncome",
                    type: "AnnualIncome",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, mostRecentEviction: {
                    name: "mostRecentEviction",
                    type: "MostRecentEviction",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                }, leaseTermsId: {
                    name: "leaseTermsId",
                    fields: ["leaseTermsId"]
                },
            },
        },
        impersonationLog: {
            name: 'ImpersonationLog', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ImpersonationLog$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ImpersonationLog$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, sessionId: {
                    name: "sessionId",
                    type: "String",
                }, primaryKey: {
                    name: "primaryKey",
                    type: "String",
                }, impersonator: {
                    name: "impersonator",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'impersonatorUser',
                }, impersonated: {
                    name: "impersonated",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'impersonatedUser',
                }, before: {
                    name: "before",
                    type: "Json",
                }, after: {
                    name: "after",
                    type: "Json",
                }, context: {
                    name: "context",
                    type: "Json",
                }, database: {
                    name: "database",
                    type: "String",
                }, schema: {
                    name: "schema",
                    type: "String",
                }, table: {
                    name: "table",
                    type: "String",
                }, operation: {
                    name: "operation",
                    type: "String",
                }, committedAt: {
                    name: "committedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, impersonatorUser: {
                    name: "impersonatorUser",
                    type: "User",
                    isDataModel: true,
                    backLink: 'impersonatorUser',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "impersonator" },
                }, impersonatedUser: {
                    name: "impersonatedUser",
                    type: "User",
                    isDataModel: true,
                    backLink: 'impersonatedUser',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "impersonated" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        impersonationSession: {
            name: 'ImpersonationSession', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ImpersonationSession$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ImpersonationSession$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, impersonator: {
                    name: "impersonator",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'impersonatorUser',
                }, impersonated: {
                    name: "impersonated",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'impersonatedUser',
                }, startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, endedAt: {
                    name: "endedAt",
                    type: "DateTime",
                    isOptional: true,
                }, isActive: {
                    name: "isActive",
                    type: "Boolean",
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": true }] }],
                }, sessionData: {
                    name: "sessionData",
                    type: "Json",
                }, impersonatorUser: {
                    name: "impersonatorUser",
                    type: "User",
                    isDataModel: true,
                    backLink: 'impersonatorSessions',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "impersonator" },
                }, impersonatedUser: {
                    name: "impersonatedUser",
                    type: "User",
                    isDataModel: true,
                    backLink: 'impersonatedSessions',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "impersonated" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        userSessionLog: {
            name: 'UserSessionLog', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$UserSessionLog$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$UserSessionLog$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, userId: {
                    name: "userId",
                    type: "String",
                    isForeignKey: true,
                    relationField: 'user',
                }, sessionStart: {
                    name: "sessionStart",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, sessionEnd: {
                    name: "sessionEnd",
                    type: "DateTime",
                    isOptional: true,
                }, userAgent: {
                    name: "userAgent",
                    type: "String",
                    isOptional: true,
                }, ipAddress: {
                    name: "ipAddress",
                    type: "String",
                    isOptional: true,
                }, userCreatedAt: {
                    name: "userCreatedAt",
                    type: "DateTime",
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'sessionLogs',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "userId" },
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        profile: {
            name: 'Profile', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Profile$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Profile$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$Profile$id,
                    isForeignKey: true,
                    relationField: 'user',
                }, user: {
                    name: "user",
                    type: "User",
                    isDataModel: true,
                    backLink: 'profile',
                    isRelationOwner: true,
                    foreignKeyMapping: { "id": "id" },
                }, emails: {
                    name: "emails",
                    type: "Email",
                    isTypeDef: true,
                    isArray: true,
                }, phoneNumbers: {
                    name: "phoneNumbers",
                    type: "PhoneNumber",
                    isTypeDef: true,
                    isArray: true,
                }, addresses: {
                    name: "addresses",
                    type: "Address",
                    isTypeDef: true,
                    isOptional: true,
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        resendEmailLog: {
            name: 'ResendEmailLog', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ResendEmailLog$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ResendEmailLog$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, fromEmail: {
                    name: "fromEmail",
                    type: "String",
                }, toEmail: {
                    name: "toEmail",
                    type: "String",
                }, subject: {
                    name: "subject",
                    type: "String",
                }, replyTo: {
                    name: "replyTo",
                    type: "String",
                    isOptional: true,
                }, resendMessageId: {
                    name: "resendMessageId",
                    type: "String",
                    isOptional: true,
                }, resendError: {
                    name: "resendError",
                    type: "String",
                    isOptional: true,
                }, resendStatusCode: {
                    name: "resendStatusCode",
                    type: "Int",
                    isOptional: true,
                }, resendErrorName: {
                    name: "resendErrorName",
                    type: "String",
                    isOptional: true,
                }, userEmail: {
                    name: "userEmail",
                    type: "String",
                }, userName: {
                    name: "userName",
                    type: "String",
                    isOptional: true,
                }, category: {
                    name: "category",
                    type: "String",
                    isOptional: true,
                }, message: {
                    name: "message",
                    type: "String",
                    isOptional: true,
                }, success: {
                    name: "success",
                    type: "Boolean",
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },
        resendWebhookLog: {
            name: 'ResendWebhookLog', fields: {
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, createdById: {
                    name: "createdById",
                    type: "String",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ResendWebhookLog$createdById,
                }, updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@updatedAt", "args": [] }],
                }, updatedById: {
                    name: "updatedById",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                    defaultValueProvider: $default$ResendWebhookLog$updatedById,
                }, deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    isOptional: true,
                }, deletedById: {
                    name: "deletedById",
                    type: "String",
                    isOptional: true,
                }, id: {
                    name: "id",
                    type: "String",
                    isId: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                }, eventType: {
                    name: "eventType",
                    type: "String",
                }, messageId: {
                    name: "messageId",
                    type: "String",
                    isOptional: true,
                }, webhookData: {
                    name: "webhookData",
                    type: "Json",
                    isOptional: true,
                }, signatureValid: {
                    name: "signatureValid",
                    type: "Boolean",
                }, signatureReceived: {
                    name: "signatureReceived",
                    type: "String",
                    isOptional: true,
                }, signatureExpected: {
                    name: "signatureExpected",
                    type: "String",
                    isOptional: true,
                }, processedAt: {
                    name: "processedAt",
                    type: "DateTime",
                    attributes: [{ "name": "@default", "args": [{ "name": "value" }] }],
                },
            }, uniqueConstraints: {
                id: {
                    name: "id",
                    fields: ["id"]
                },
            },
        },

    },
    typeDefs: {
        email: {
            name: 'Email', fields: {
                type: {
                    name: "type",
                    type: "EmailType",
                }, email: {
                    name: "email",
                    type: "String",
                }, verifiedAt: {
                    name: "verifiedAt",
                    type: "DateTime",
                    isOptional: true,
                }, verifiedBy: {
                    name: "verifiedBy",
                    type: "String",
                    isOptional: true,
                },
            },
        },
        phoneNumber: {
            name: 'PhoneNumber', fields: {
                type: {
                    name: "type",
                    type: "PhoneNumberType",
                }, telephony: {
                    name: "telephony",
                    type: "PhoneNumberTelephony",
                }, phoneNumber: {
                    name: "phoneNumber",
                    type: "String",
                }, verifiedAt: {
                    name: "verifiedAt",
                    type: "DateTime",
                    isOptional: true,
                }, verifiedBy: {
                    name: "verifiedBy",
                    type: "String",
                    isOptional: true,
                },
            },
        },
        website: {
            name: 'Website', fields: {
                type: {
                    name: "type",
                    type: "WebsiteType",
                }, url: {
                    name: "url",
                    type: "String",
                }, verifiedAt: {
                    name: "verifiedAt",
                    type: "DateTime",
                    isOptional: true,
                }, verifiedBy: {
                    name: "verifiedBy",
                    type: "String",
                    isOptional: true,
                },
            },
        },
        latitudeLongitude: {
            name: 'LatitudeLongitude', fields: {
                latitude: {
                    name: "latitude",
                    type: "Float",
                }, longitude: {
                    name: "longitude",
                    type: "Float",
                },
            },
        },
        address: {
            name: 'Address', fields: {
                type: {
                    name: "type",
                    type: "AddressType",
                }, streetLine1: {
                    name: "streetLine1",
                    type: "String",
                }, streetLine2: {
                    name: "streetLine2",
                    type: "String",
                    isOptional: true,
                }, city: {
                    name: "city",
                    type: "String",
                    isOptional: true,
                }, state: {
                    name: "state",
                    type: "String",
                    isOptional: true,
                }, zipCode: {
                    name: "zipCode",
                    type: "String",
                    isOptional: true,
                }, country: {
                    name: "country",
                    type: "String",
                    isOptional: true,
                    attributes: [{ "name": "@default", "args": [{ "name": "value", "value": "US" }] }],
                }, location: {
                    name: "location",
                    type: "LatitudeLongitude",
                    isTypeDef: true,
                    isOptional: true,
                }, verifiedAt: {
                    name: "verifiedAt",
                    type: "DateTime",
                    isOptional: true,
                }, verifiedBy: {
                    name: "verifiedBy",
                    type: "String",
                    isOptional: true,
                },
            },
        },
        listingDetails: {
            name: 'ListingDetails', fields: {
                housingDetails: {
                    name: "housingDetails",
                    type: "HousingDetails",
                    isTypeDef: true,
                    isOptional: true,
                }, address: {
                    name: "address",
                    type: "Address",
                    isTypeDef: true,
                    isOptional: true,
                },
            },
        },
        housingDetails: {
            name: 'HousingDetails', fields: {
                bedrooms: {
                    name: "bedrooms",
                    type: "String",
                    isOptional: true,
                }, bathrooms: {
                    name: "bathrooms",
                    type: "String",
                    isOptional: true,
                }, squareFootage: {
                    name: "squareFootage",
                    type: "Int",
                    isOptional: true,
                }, neighborhood: {
                    name: "neighborhood",
                    type: "String",
                    isOptional: true,
                }, amenities: {
                    name: "amenities",
                    type: "String",
                    isArray: true,
                    isOptional: true,
                },
            },
        },

    },
    deleteCascade: {
        user: ['Session', 'Account', 'Member'],
        organization: ['Member', 'Invitation', 'Business'],

    },
    authModel: 'User'

};

function $default$File$createdById(user: any): unknown {
    return user?.id;
}

function $default$File$updatedById(user: any): unknown {
    return user?.id;
}

function $default$FileAccessControl$createdById(user: any): unknown {
    return user?.id;
}

function $default$FileAccessControl$updatedById(user: any): unknown {
    return user?.id;
}

function $default$FeaturedListing$createdById(user: any): unknown {
    return user?.id;
}

function $default$FeaturedListing$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Listing$createdById(user: any): unknown {
    return user?.id;
}

function $default$Listing$updatedById(user: any): unknown {
    return user?.id;
}

function $default$ForLease$createdById(user: any): unknown {
    return user?.id;
}

function $default$ForLease$updatedById(user: any): unknown {
    return user?.id;
}

function $default$AuctionFormat$createdById(user: any): unknown {
    return user?.id;
}

function $default$AuctionFormat$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Bid$createdById(user: any): unknown {
    return user?.id;
}

function $default$Bid$updatedById(user: any): unknown {
    return user?.id;
}

function $default$SavedListing$createdById(user: any): unknown {
    return user?.id;
}

function $default$SavedListing$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Comment$createdById(user: any): unknown {
    return user?.id;
}

function $default$Comment$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Reply$createdById(user: any): unknown {
    return user?.id;
}

function $default$Reply$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Business$createdById(user: any): unknown {
    return user?.id;
}

function $default$Business$updatedById(user: any): unknown {
    return user?.id;
}

function $default$PropertySeeker$createdById(user: any): unknown {
    return user?.id;
}

function $default$PropertySeeker$updatedById(user: any): unknown {
    return user?.id;
}

function $default$PropertySeeker$id(user: any): unknown {
    return user?.id;
}

function $default$TenantScreeningCriteria$createdById(user: any): unknown {
    return user?.id;
}

function $default$TenantScreeningCriteria$updatedById(user: any): unknown {
    return user?.id;
}

function $default$ImpersonationLog$createdById(user: any): unknown {
    return user?.id;
}

function $default$ImpersonationLog$updatedById(user: any): unknown {
    return user?.id;
}

function $default$ImpersonationSession$createdById(user: any): unknown {
    return user?.id;
}

function $default$ImpersonationSession$updatedById(user: any): unknown {
    return user?.id;
}

function $default$UserSessionLog$createdById(user: any): unknown {
    return user?.id;
}

function $default$UserSessionLog$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Profile$createdById(user: any): unknown {
    return user?.id;
}

function $default$Profile$updatedById(user: any): unknown {
    return user?.id;
}

function $default$Profile$id(user: any): unknown {
    return user?.id;
}

function $default$ResendEmailLog$createdById(user: any): unknown {
    return user?.id;
}

function $default$ResendEmailLog$updatedById(user: any): unknown {
    return user?.id;
}

function $default$ResendWebhookLog$createdById(user: any): unknown {
    return user?.id;
}

function $default$ResendWebhookLog$updatedById(user: any): unknown {
    return user?.id;
}
export default metadata;
